const routes = {
  getRoles: 'role/',
  getRoleById: 'role/:role_id',
  createRole: 'role/',
  updateRole: 'role/:role_id',
  deleteRole: 'role/:role_id',
  getRolePermissions: 'role/:role_id/permissions',
  assignPermissions: 'role/:role_id/permissions',
  removePermissions: 'role/:role_id/permissions'
};

export default routes;